<template>
	<th class="px-1.5 py-2 text-left text-xs font-semibold text-gray-900 sm:px-3 sm:py-3.5 md:text-sm">
		<slot />
	</th>
</template>
